const { getRelatedShowPageData } = require('../show/showUtils');
const { mainTaxFields, allTaxFields } = require('../taxonomy/taxFieldsConfig');

const getHubPage = content => {
  if (content.primaryTaxonomy?.entity?.hubPage) {
    const hubPage = { ...content.primaryTaxonomy.entity.hubPage };
    if (content.taxPrimaryOptTitle) {
      hubPage.title = content.taxPrimaryOptTitle;
    }
    if (content.taxPrimaryOptLink?.url?.path) {
      hubPage.url = content.taxPrimaryOptLink.url.path;
    }
    if (hubPage.title || hubPage.url) {
      return hubPage;
    }
  }
  return null;
};

const getParentHubPages = content => {
  const parents = content?.primaryTaxonomy?.entity?.parents;
  if (parents) {
    return parents
      .filter(parent => parent.hubPage)
      .map(parent => parent.hubPage);
  }
  return null;
};

const getSecondaryHubPages = (
  content,
  options = { sorted: false, includeParents: false, useAllTaxonomies: false }
) => {
  const hubPages = [];
  const taxFields = options.useAllTaxonomies ? allTaxFields : mainTaxFields;
  taxFields.forEach(taxonomyName => {
    if (typeof content[taxonomyName] !== 'undefined') {
      content[taxonomyName].forEach(taxonomyEntity => {
        if (taxonomyEntity.entity?.hubPage?.url) {
          hubPages.push(taxonomyEntity.entity.hubPage);
          if (options.includeParents && taxonomyEntity.entity.parents) {
            taxonomyEntity.entity.parents.forEach(parentTaxonomyEntity => {
              if (parentTaxonomyEntity.hubPage?.url) {
                hubPages.push(parentTaxonomyEntity.hubPage);
              }
            });
          }
        }
      });
    }
  });

  if (options.sorted) {
    return Object.values(hubPages).sort((a, b) => {
      const titleA = a.title.toUpperCase(); // ignore upper and lowercase
      const titleB = b.title.toUpperCase(); // ignore upper and lowercase
      if (titleA < titleB) {
        return -1;
      }
      if (titleA > titleB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
  }

  return hubPages;
};

const getHubPages = (
  content,
  options = {
    sorted: false,
    includeParents: false,
    includeShowPage: false
  }
) => {
  const hubPages = {};
  const hubPage = getHubPage(content);
  if (hubPage) {
    hubPages[hubPage.url] = hubPage;
  }
  if (options.includeParents) {
    const parentHubPages = getParentHubPages(content);

    if (parentHubPages) {
      parentHubPages.forEach(parentHubPage => {
        hubPages[parentHubPage.url] = parentHubPage;
      });
    }
  }

  const secondaryHubPages = getSecondaryHubPages(content, options);
  if (secondaryHubPages) {
    secondaryHubPages.forEach(secondaryHubPage => {
      hubPages[secondaryHubPage.url] = secondaryHubPage;
    });
  }

  if (options.includeShowPage) {
    const relatedShowPageData = getRelatedShowPageData(content);
    // If content has a relation with "show_page", treat it as a taxonomy
    if (relatedShowPageData) {
      hubPages[relatedShowPageData.url] = relatedShowPageData;
    }
  }

  return Object.values(hubPages);
};

module.exports = {
  getSecondaryHubPages,
  getHubPages,
  getHubPage
};
